import React from 'react';

import Icon from '../Icon/Icon';

const TroubleshootVeevBlueIcon = (props) => {
    return (
        <Icon width='48' height='48' {...props}>
            <g fill='none' fillRule='evenodd'>
                <g transform='rotate(19 -9.393 97.198)'>
                    <path
                        d='M1.377 8.896c-.15 0-.307.01-.47.032L.156 6.904C.512 2.301.936 0 1.426 0h6.14c.563 0 1.039 3.043 1.426 9.13-.51-.156-.969-.234-1.377-.234H1.377z'
                        stroke='#34303D'
                        strokeWidth='2'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M4.496 9.13H1.377l-.386.133 7.232 21.003M4.496 9.13h3.119c.408 0 .867.057 1.377.17.041 13.8-.22 20.7-.784 20.7'
                        stroke='#34303D'
                        strokeWidth='2'
                        fill='#00D1D2'
                        strokeLinejoin='round'
                    />
                    <rect fill='#34303D' x='3.853' y='3.261' width='1.286' height='3.913' rx='.643' />
                </g>
                <g transform='translate(9 6)'>
                    <rect stroke='#34303D' strokeWidth='2' x='1' y='1' width='19' height='34' rx='3' />
                    <path
                        stroke='#00D1D2'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        d='M4.5 4.673h12'
                    />
                    <circle fill='#00D1D2' cx='10.5' cy='18' r='7.5' />
                    <path
                        d='M10.813 12a1 1 0 0 1 .996.909l.074.807c.348.113.677.266.983.455.017-.016.039-.036.061-.054l.48-.404a1 1 0 0 1 1.35.06l.231.23a1 1 0 0 1 .062 1.347l-.402.482c-.041.05-.086.094-.135.134.106.205.196.422.269.646l.805.07a1 1 0 0 1 .913.997v.634a1 1 0 0 1-.909.996l-.807.074a4.476 4.476 0 0 1-.385.866 1 1 0 0 1 .08.083l.403.48a1 1 0 0 1-.06 1.35l-.23.23a1 1 0 0 1-1.346.062l-.483-.401a1.008 1.008 0 0 1-.106-.103 4.46 4.46 0 0 1-.77.332l-.07.805a1 1 0 0 1-.996.913h-.634a1 1 0 0 1-.996-.909l-.074-.807a4.471 4.471 0 0 1-.65-.268l-.065.074a1 1 0 0 1-.064.059l-.48.403a1 1 0 0 1-1.35-.06l-.23-.23a1 1 0 0 1-.062-1.346l.401-.483.058-.061a4.479 4.479 0 0 1-.457-.984l-.805-.07a1 1 0 0 1-.913-.997v-.634a1 1 0 0 1 .909-.996l.807-.074c.087-.27.199-.527.333-.772a1 1 0 0 1-.102-.102l-.404-.481a1 1 0 0 1 .06-1.35l.23-.23a1 1 0 0 1 1.347-.062l.482.402.086.081c.271-.157.56-.287.864-.385l.07-.805A1 1 0 0 1 10.18 12h.634zm-.313 3a3 3 0 1 0 0 6 3 3 0 0 0 0-6z'
                        fill='#34303D'
                    />
                </g>
            </g>
        </Icon>
    );
};

export default TroubleshootVeevBlueIcon;
